import messages from "./messages.vue"

const Messages = {
  install(Vue) {
    Vue.component("messages", messages)
    Vue.prototype.$messages = async function(id) {
      try {
        const promise = await _$.progress.create()

        const $package = {
          id: id,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("messages", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Messages
